// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carouselSimple_carousel__2vk3Q","arrow":"carouselSimple_arrow__1Bb_Z","arrowRight":"carouselSimple_arrowRight__3hGtJ","arrowLeft":"carouselSimple_arrowLeft__DhFRG"};